/**
 * Utility function to build comparables loader criteria array
 *
 * Extracted from CompanyDetails.jsx to reduce file size and improve maintainability.
 *
 * @module comparablesLoaderCriteria
 */

import { PROFILER_SEARCH_FIELDS } from '../../../../utils/constants/fields';
import { PUNCTUATION } from '../../../../utils/constants/notation';
import { formatNumberRange } from '../../../../utils/utils';

/**
 * Build criteria array for comparables search loader
 *
 * @param {Object} criteriaFields - The criteria fields from similarCompaniesState
 * @returns {Array} Array of criteria objects with name and display properties
 */
export const buildComparablesLoaderCriteria = (criteriaFields) => {
  const criteria = [];

  if (criteriaFields[PROFILER_SEARCH_FIELDS.INDUSTRY.NAME]) {
    criteria.push({
      name: 'Industry',
      display: criteriaFields[PROFILER_SEARCH_FIELDS.INDUSTRY.NAME]
    });
  }

  if (criteriaFields[PROFILER_SEARCH_FIELDS.VALUE_CHAIN.NAME]) {
    criteria.push({
      name: 'Value chain',
      display: criteriaFields[PROFILER_SEARCH_FIELDS.VALUE_CHAIN.NAME]
    });
  }

  if (criteriaFields[PROFILER_SEARCH_FIELDS.PRODUCT_PORTFOLIO.NAME]) {
    criteria.push({
      name: 'Product portfolio',
      display: criteriaFields[PROFILER_SEARCH_FIELDS.PRODUCT_PORTFOLIO.NAME]
    });
  }

  if (
    criteriaFields[PROFILER_SEARCH_FIELDS.REVENUE_MIN.NAME] ||
    criteriaFields[PROFILER_SEARCH_FIELDS.REVENUE_MAX.NAME]
  ) {
    criteria.push({
      name: 'Sales (€M)',
      display: formatNumberRange(
        criteriaFields[PROFILER_SEARCH_FIELDS.REVENUE_MIN.NAME],
        criteriaFields[PROFILER_SEARCH_FIELDS.REVENUE_MAX.NAME],
        PUNCTUATION.EN_DASH,
        true
      )
    });
  }

  return criteria;
};
